import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnInit,
  ViewChild, Inject,
} from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-homebanners',
  templateUrl: './homebanners.component.html',
  styleUrls: ['./homebanners.component.css'],
})
export class HomebannersComponent implements OnInit {
  @Input() homeBanners: any;
  config: SwiperOptions = {
    init: true,
    navigation: false,
    centeredSlides: true,
    centerInsufficientSlides: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    cssMode:true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    loop: true,
    updateOnWindowResize: true,
    loopAdditionalSlides: 8,
    spaceBetween: 10,
    breakpoints: {
      320: {
        slidesPerGroup: 1,
        spaceBetween: 10,
      },
      580: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 3,
      },
      1440: {
        slidesPerView: 3,
        loopAdditionalSlides: 9,
      },
    }
  };
  @ViewChild('bannerSlide') swiper!: ElementRef<SwiperContainer>;
  bannersUrls: string[] = [];
  bannerHref: string[] = [];

  constructor( @Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {

    this.homeBanners.forEach((element) => {
      let htmlObj = this.document.createElement('a');
      htmlObj.innerHTML = element;
      this.bannersUrls.push(htmlObj.lastChild.childNodes[1]['src']);
      this.bannerHref.push(htmlObj.childNodes[0]['href']);
    });

  }
  ngAfterViewInit(): void{
    Object.assign(this.swiper, this.config);
    this.swiper.nativeElement.initialize();
    this.swiper.nativeElement.swiper.slideNext();
    // console.log('this is the initial slide: ' + this.swiper.nativeElement.swiper.activeIndex);
    // });
  }
}
